import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

// -----------------------------------------------------------------
// Replace YOUR_PROJECT_ID with your actual Sanity project ID.
// Run `npx sanity init` inside sanity-studio/ to create your project
// and get the project ID from sanity.io/manage.
// -----------------------------------------------------------------
export const client = sanityClient({
  projectId: '9yx7a41q',
  dataset: 'production',
  useCdn: true,          // serve cached data in production
})

// Helper to build image URLs from Sanity image references
const builder = imageUrlBuilder(client)
export const urlFor = (source) => builder.image(source)

// Convenience wrapper — throws an error with context on failure
export async function sanityFetch(query, params = {}) {
  try {
    return await client.fetch(query, params)
  } catch (err) {
    console.error('[Sanity] Query failed:', query, err)
    return null
  }
}
